<ul navAccordion class="matero-sidemenu level-0">
  @for (menuItem of menus | async; track menuItem) {
    <li
      navAccordionItem
      class="matero-sidemenu-item"
      routerLinkActive="active"
      [group]="menuItem.route"
      [type]="menuItem.type"
    >
      @if (menuItem.type === 'link') {
        <a
          class="matero-sidemenu-link"
          [routerLink]="buildRoute([menuItem.route])"
          matRipple
          [matRippleDisabled]="!ripple"
        >
          <mat-icon class="menu-icon">{{ menuItem.icon }}</mat-icon>
          <span class="menu-name" [innerHtml]="menuItem.name | translate"></span>
          @if (menuItem.label) {
            <span
              class="menu-label bg-{{ menuItem.label.color }}"
              [innerHtml]="menuItem.label.value"
            >
            </span>
          }
          <span class="flex-1"></span>
          @if (menuItem.badge) {
            <span class="menu-badge bg-{{ menuItem.badge.color }}">
              {{ menuItem.badge.value }}
            </span>
          }
        </a>
      }
      @if (menuItem.type === 'extLink') {
        <a
          class="matero-sidemenu-link"
          [href]="menuItem.route"
          matRipple
          [matRippleDisabled]="!ripple"
        >
          <mat-icon class="menu-icon">{{ menuItem.icon }}</mat-icon>
          <span class="menu-name" [innerHtml]="menuItem.name | translate"></span>
          @if (menuItem.label) {
            <span
              class="menu-label bg-{{ menuItem.label.color }}"
              [innerHtml]="menuItem.label.value"
            >
            </span>
          }
          <span class="flex-1"></span>
        </a>
      }
      <!-- level 1 -->
      @if (menuItem.type === 'sub') {
        <a
          navAccordionToggle
          class="matero-sidemenu-toggle"
          matRipple
          [matRippleDisabled]="!ripple"
        >
          <mat-icon class="menu-icon">{{ menuItem.icon }}</mat-icon>
          <span class="menu-name">{{ menuItem.name | translate }}</span>
          @if (menuItem.label) {
            <span class="menu-label bg-{{ menuItem.label.color }}">
              {{ menuItem.label.value }}
            </span>
          }
          <span class="flex-1"></span>
          @if (menuItem.badge) {
            <span class="menu-badge bg-{{ menuItem.badge.color }}">
              {{ menuItem.badge.value }}
            </span>
          }
          <mat-icon class="menu-caret">arrow_drop_down</mat-icon>
        </a>
      }
      @if (menuItem.type === 'sub') {
        <ul navAccordion class="matero-sidemenu matero-sidemenu-sub level-1">
          @for (childLvl1 of menuItem.children; track childLvl1) {
            <li
              navAccordionItem
              class="matero-sidemenu-item"
              routerLinkActive="active"
              [group]="childLvl1.route"
              [type]="childLvl1.type"
            >
              @if (childLvl1.type === 'link') {
                <a
                  class="matero-sidemenu-link"
                  [routerLink]="buildRoute([menuItem.route, childLvl1.route])"
                  matRipple
                  [matRippleDisabled]="!ripple"
                >
                  <mat-icon class="menu-icon">{{ childLvl1.icon }}</mat-icon>
                  <span class="menu-name">{{ childLvl1.name | translate }}</span>
                </a>
              }
              @if (childLvl1.type === 'extLink') {
                <a
                  class="matero-sidemenu-link"
                  [href]="childLvl1.route"
                  matRipple
                  [matRippleDisabled]="!ripple"
                >
                  <span class="menu-name">{{ childLvl1.name | translate }}</span>
                  <span class="flex-1"></span>
                  <mat-icon class="menu-caret">launch</mat-icon>
                </a>
              }
              @if (childLvl1.type === 'extTabLink') {
                <a
                  class="matero-sidemenu-link"
                  [href]="childLvl1.route"
                  target="_blank"
                  matRipple
                  [matRippleDisabled]="!ripple"
                >
                  <span class="menu-name">{{ childLvl1.name | translate }}</span>
                  <span class="flex-1"></span>
                  <mat-icon class="menu-caret">launch</mat-icon>
                </a>
              }
              <!-- level 2 -->
              @if (childLvl1.type === 'sub') {
                <a
                  navAccordionToggle
                  class="matero-sidemenu-toggle"
                  matRipple
                  [matRippleDisabled]="!ripple"
                >
                  <span class="menu-name">{{ childLvl1.name | translate }}</span>
                  <span class="flex-1"></span>
                  <mat-icon class="menu-caret">arrow_drop_down</mat-icon>
                </a>
              }
              @if (childLvl1.type === 'sub') {
                <ul class="matero-sidemenu matero-sidemenu-sub level-2">
                  @for (childLvl2 of childLvl1.children; track childLvl2) {
                    <li class="matero-sidemenu-item" routerLinkActive="active">
                      @if (childLvl2.type === 'link') {
                        <a
                          class="matero-sidemenu-link"
                          [routerLink]="
                            buildRoute([menuItem.route, childLvl1.route, childLvl2.route])
                          "
                          matRipple
                          [matRippleDisabled]="!ripple"
                        >
                          <span class="menu-name">{{ childLvl2.name | translate }}</span>
                        </a>
                      }
                      @if (childLvl2.type === 'extLink') {
                        <a
                          class="matero-sidemenu-link"
                          [href]="childLvl2.route"
                          matRipple
                          [matRippleDisabled]="!ripple"
                        >
                          <span class="menu-name">{{ childLvl2.name | translate }}</span>
                          <span class="flex-1"></span>
                          <mat-icon class="menu-caret">launch</mat-icon>
                        </a>
                      }
                      @if (childLvl2.type === 'extTabLink') {
                        <a
                          class="matero-sidemenu-link"
                          [href]="childLvl2.route"
                          target="_blank"
                          matRipple
                          [matRippleDisabled]="!ripple"
                        >
                          <span class="menu-name">{{ childLvl2.name | translate }}</span>
                          <span class="flex-1"></span>
                          <mat-icon class="menu-caret">launch</mat-icon>
                        </a>
                      }
                    </li>
                  }
                </ul>
              }
            </li>
          }
        </ul>
      }
    </li>
  }
</ul>
